import { render, staticRenderFns } from "./DashboardIncomingMessages.vue?vue&type=template&id=476a57e2&scoped=true"
import script from "./DashboardIncomingMessages.vue?vue&type=script&lang=js"
export * from "./DashboardIncomingMessages.vue?vue&type=script&lang=js"
import style0 from "./DashboardIncomingMessages.vue?vue&type=style&index=0&id=476a57e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a57e2",
  null
  
)

export default component.exports